import React, { useState } from 'react';

import styled from 'styled-components';

import {
    useIsContactConnectionItemDefault,
    useEditContactConnectionItemDefault,
} from '@hooks/API/Contact/UseContactConnections';

import FlexContainer from '@components/Gui/FlexContainer';
import { InMailingLists, MailLine } from '@components/Gui/NwContactInfo';
import NwDropDownMenu from '@components/Gui/NwDropDownMenu';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const DefaultItem = styled.div`
    font-weight: ${(props) => props.isDefault && 'bold'};
`;

const EmailItem = ({ email, readOnly, noMainIcon, onEdit, onDelete, contactID, onAddToMailingList }) => {
    const [selectedEmail, setSelectedEmail] = useState();

    const { mutate: onSetItemDefault } = useEditContactConnectionItemDefault();

    const setDefault = () => {
        onSetItemDefault({ itemType: 'email', idItem: email.ID, contactID: contactID });
    };

    const handleAddToMailingList = () => {
        onAddToMailingList(email);
    };

    const isDefault = useIsContactConnectionItemDefault('email', email.ID, contactID);

    let actions = [
        { name: '', key: 'edit', pinned: true, icon: byPrefixAndName.fasl['pen'], action: onEdit },
        { name: 'set as default', key: 'default', icon: byPrefixAndName.fasl['bookmark'], action: setDefault },
        {
            name: 'add to mailing list',
            key: 'mail',
            icon: byPrefixAndName.fass['plus-circle'],
            action: handleAddToMailingList,
        },
        {
            name: 'delete',
            type: 'delete',
            key: 'delete',
            icon: byPrefixAndName.fasl['trash-alt'],
            confirmationPlacement: 'left',
            action: onDelete,
        },
    ];

    actions = actions.filter((action) => !(action.key === 'default' && isDefault));

    return (
        <FlexContainer justifyContent="space-between">
            <DefaultItem isDefault={isDefault}>
                <MailLine mailAddress={email.Address} mailCC={email.CC} />
                <InMailingLists mailingLists={email.MailingLists} onAddToMailingList={handleAddToMailingList} />
            </DefaultItem>
            {!readOnly && <NwDropDownMenu size="small" actions={actions} />}
        </FlexContainer>
    );
};

export default EmailItem;
